import { rem } from '@thiememeulenhoff/lit-sdk';
import { css } from 'lit';
import { tagName } from '../../../helpers';

export const tag = tagName('confirmation-modal');

export const styles = [
  css`
    :host {
      --width: ${rem(450)};
    }

    :where(dialog) {
      inline-size: var(--width);
    }

    footer {
      display: flex;
      gap: ${rem(16)};
    }

    :host([sticky-footer]) :where(dialog) {
      display: flex;
      flex-direction: column;
      max-block-size: 80vh; /* Ensure the modal doesn't take too much vertical space */
    }

    :host([sticky-footer]) container {
      block-size: 100%;
      flex: 1;
      overflow-y: auto;
    }

    main {
      flex: 1;
      padding-block: ${rem(12)};
    }

    :host([sticky-footer]) main {
      overflow-y: auto;
    }

    :host([sticky-footer]) footer {
      flex-shrink: 0;
      margin-block-start: ${rem(10)};
      padding: ${rem(10)};
      position: relative;
    }
  `,
];
